/**
 * 05 §3 aim assist: if an enemy centre lies within `coneDeg` of the bearing and
 * beyond `minDist`, return the bearing to the enemy nearest the aim; else null.
 * Gamepad default (spec); the mouse gets it only behind `input.mouseAimAssist`
 * (playtest experiment, 2026-09-13 — see 05 §3).
 */
export interface AimPoint { x: number; z: number }

export function assistAngle(a: number, me: AimPoint, enemies: readonly AimPoint[], coneDeg = 6, minDist = 4): number | null {
  const cone = (coneDeg * Math.PI) / 180
  let best: number | null = null, bestD = Infinity
  for (const q of enemies) {
    const dx = q.x - me.x, dz = q.z - me.z
    if (Math.hypot(dx, dz) <= minDist) continue
    const ang = Math.atan2(dz, dx)
    let d = ang - a
    while (d > Math.PI) d -= 2 * Math.PI
    while (d < -Math.PI) d += 2 * Math.PI
    if (Math.abs(d) < cone && Math.abs(d) < bestD) { best = ang; bestD = Math.abs(d) }
  }
  return best
}
